import React from 'react';
import Modal from 'Modal.js';
import S from 'StyledModal.js';
import {CSSTransition} from 'react-transition-group';
import styled from 'styled-components';

const duration = 300;
const ModalWithOpacityStyles = styled(Modal)`
  &.modal-opacity-enter {
    opacity: 0.01;
  }
  &.modal-opacity-enter-active {
   transition: opacity ${duration}ms;
   opacity: 1;
  }
  &.modal-opacity-exit {
    opacity: 1;
  }
  &.modal-opacity-exit-active {
    opacity: 0.01;
    transition: opacity ${duration}ms ease-in;
  }
  & ${S.ModalBody}{
    padding: 0;
    height: 100%;
  }
  & ${S.ModalHeader}{
    padding: 0;
    margin: 0;
  }
  & ${S.ModalWrapper}{
    overflow: visible;
    margin: 5rem;
    border-radius: 0.42rem;
    height: 85vh;
    max-height: 66.67rem;
    min-width: 64.67rem;
    width: 100%;
    max-width: 75rem;
    padding: 0;
    background-color: transparent;
  }
`;

const AccountModal = ({isOpen, toggleOpen, children}) => {
    return (
        <>
        <CSSTransition in={isOpen}
                       className="modal-transition"
                       classNames="modal-transition"
                       unmountOnExit
                       timeout={duration}>

            <ModalWithOpacityStyles
                showHeaderIcon={false}
                showCloseIcon={true}
                showHeaderTitle={false}
                open={isOpen}
                onClose={toggleOpen}>
                {children}
            </ModalWithOpacityStyles>

        </CSSTransition>
        </>
    );
};

export default AccountModal;